export default __webpack_public_path__ + "static/media/facebook-icon-pink.aaba0e2e.svg";